/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * The MinMaxCollector is used to find minimums and maximums based on one or more values for one or more measures.
 * The table it owns is keyed one per measure item.
 **/
class MinMaxCollector {
	/**
	 * @Constructor
	 * @param {Object} options
	 */
	constructor() {
		this.minMaxTable = {};
	}

	/**
	 * Clear out the minMaxTable for starting a new pass through the data.
	 */
	reset() {
		this.minMaxTable={};
	}

	/**
	 * get the minmax entry for the passed key (or add a new minmaxEntry)
	 * @param dataItemUniqueId - the id of the dataItem to return the minMaxEntry for.
	 * @returns the minmax entry.
	 */
	getMinMaxEntry(dataItemUniqueId) {
		if (!this.minMaxTable[dataItemUniqueId]) {
			this._initializeMinMaxEntry(dataItemUniqueId);
		}
		return this.minMaxTable[dataItemUniqueId];
	}

	/**
	 * incorporate a single value into the minmax
	 * @param minmaxEntry - the minmaxEntry of interest
	 * @param value - the value to incorporate
	 */
	updateMinMaxEntry(minmaxEntry, value) {
		if (minmaxEntry.maxUse===undefined || minmaxEntry.maxUse < value) {
			minmaxEntry.maxUse = value;
		}
		if (minmaxEntry.minUse===undefined || minmaxEntry.minUse > value) {
			minmaxEntry.minUse = value;
		}
	}

	/**
	 * add a new minmaxItemEntry to the minMaxTable.
	 * @param itemKey - the key (unique to this measure)
	 * @param dataItemUniqueId - the uniqueId of the dataItem.
	 */
	_initializeMinMaxEntry(dataItemUniqueId) {
		this.minMaxTable[dataItemUniqueId]={
			dataItemUniqueId: dataItemUniqueId
		};
	}
}

export default MinMaxCollector;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-crosshairs/src/js/MinMaxCollector.js